export const chartsOrder = {
  teachersAccessCount: 1,
  teachersUsageTime: 2,
  teachersAccessHour: 3,
  studentsAccessCount: 4,
  studentsAccessHour: 5,
  studentsUsageTimeByPhases: 6,
  studentsUsageTimeBySessionType: 7,
  firstAssignmentCompetencialNeuroDevelopmentAnalysis: 8,
  firstAssignmentCalculationAndNumerationNeuropsychologicalModelAnalysis: 9,
  firstAssignmentArithmeticProblemSolvingCognitiveModelAnalysis: 10,
  firstAssignmentGeometryMeasurementAndInformationProcessingAnalysis: 11,
  fisiologicalAgeCompetencialNeuroDevelopmentAnalysis: 12,
  fisiologicalAgeCalculationAndNumerationNeuropsychologicalModelAnalysis: 13,
  fisiologicalAgeArithmeticProblemSolvingCognitiveModelAnalysis: 14,
  fisiologicalAgeGeometryMeasurementAndInformationProcessingAnalysis: 15,
  firstAssignmentCognitiveStyleAnalysis: 16,
  fisiologicalAgeCognitiveStyleAnalysis: 17,
  firstAssignmentMetacognitionAnalysis: 18,
  fisiologicalAgeMetacognitionAnalysis: 19,
};
